import dayjs, { Dayjs } from "dayjs";
import i18next from "i18next";
import { DEFAULT_DATE_FORMAT } from "Services/constants";
import { Rule } from "./ValidationTypes";

export const createDateAfterRule = (date: Dayjs, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Date must be after {{date}}", { date: date.format(DEFAULT_DATE_FORMAT) }),
		validateImmediately,
	},
	type: "date_after",
	validate: async (value) => value !== undefined && dayjs(value).isAfter(date),
});

export const createDateSameOrAfterRule = (date: Dayjs, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Date must be same or after {{date}}", { date: date.format(DEFAULT_DATE_FORMAT) }),
		validateImmediately,
	},
	type: "date_same_or_after",
	validate: async (value) => value !== undefined && dayjs(value).isSameOrAfter(date),
});

export const createDateBeforeRule = (date: Dayjs, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Date must be before {{date}}", { date: date.format(DEFAULT_DATE_FORMAT) }),
		validateImmediately,
	},
	type: "date_before",
	validate: async (value) => value !== undefined && dayjs(value).isBefore(date),
});

export const createDateSameOrBeforeRule = (date: Dayjs, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Date must be same or before {{date}}", { date: date.format(DEFAULT_DATE_FORMAT) }),
		validateImmediately,
	},
	type: "date_same_or_before",
	validate: async (value) => value !== undefined && dayjs(value).isSameOrBefore(date),
});

export const createDateBetweenInclusiveRule = (
	from: Dayjs,
	to: Dayjs,
	message?: string,
	validateImmediately?: boolean
): Rule => ({
	message: {
		text:
			message ??
			i18next.t("Date must be between {{from}} and {{to}}", {
				from: from.format(DEFAULT_DATE_FORMAT),
				to: to.format(DEFAULT_DATE_FORMAT),
			}),
		validateImmediately,
	},
	type: "date_between_inclusive",
	validate: async (value: Dayjs) => value !== undefined && value.isSameOrAfter(from) && value.isSameOrBefore(to),
});
